import React from "react"
import isEmpty from "validator/lib/isEmpty"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import classes from "./TdSaveButton.module.scss"

const TdSaveButton = props => {
  const {
    form,
    tables,
    setTables,
    selectedTable,
    setLayout,
    setSelectedFloor
  } = props

  const [t] = useTranslation()

  const validate = () => {
    const tableNumberExists =
      tables.some((table, tableIndex) =>
        table.tableNumber === form.tableNumber.trim() &&
        tableIndex !== selectedTable?.tableIndex
      )

    if (tableNumberExists) {
      toast.error(t("شماره_میز_تکراری_است"))

      return false
    }

    if (isEmpty(form.tableNumber)) {
      toast.error(t("اسم_میز_الزامی_است"))

      return false
    }

    if (isEmpty(form.level)) {
      toast.error(t("طبقه_الزامی_است"))

      return false
    }

    if (isEmpty(typeof form.capacity)) {
      toast.error(t("ظرفیت_الزامی_است"))

      return false
    }

    return true
  }

  const handleEdit = async () => {
    if (!validate()) return

    setTables(prev =>
      prev.map(t =>
        t.tableNumber === selectedTable.tableNumber
          ?
          {
            ...t,
            ...form,
            capacity: Number(form.capacity)
          }
          :
          t
      )
    )

    setLayout("list")
  }

  const handleSave = async () => {
    if (!validate()) return

    const newTable = {
      ...form,
      available: false,
      position: { x: 0, y: 0 },
      status: "ready",
      capacity: Number(form.capacity)
    }

    setTables(prev => [newTable, ...prev])

    setSelectedFloor(form.level)

    setLayout("list")
  }

  const editMode = !!selectedTable

  return (
    <div className={classes["footer"]}>
      <Button
        fullWidth
        color="success"
        onClick={editMode ? handleEdit : handleSave}
      >
        {editMode ? t("ویرایش_میز") : t("افزودن_میز")} 
      </Button>
      <Button
        fullWidth
        color="danger"
        className={classes["button"]}
        onClick={() => setLayout("list")}
      >
        {editMode ? t("لغو_ویرایش") : t("بازگشت")}
      </Button>
    </div>
  )
}

export default TdSaveButton